import React, { PureComponent } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';

import { Input, CustomSelect } from '../../common/components';
import { getWarrantyDict, saveCompanyGroupWarranty, getCompanyGroups } from '../services/dictionary.service';
import WarrantyCompanyGroupModel from '../models/warrantyCompanyGroup.model';


const getOptionLabel = (option) => option.name;

const getOptionValue = (option) => option.id;
class DictWarrantyCompanyGroupForm extends PureComponent {
  state = {
    price: 0,
    actualPrice: 0,
    group: null,
  };

  async componentDidMount() {
    const { match: { params }, location: { state } } = this.props;

    const warrantyDict = await getWarrantyDict(params.id);
    const { data: companyGroups } = await getCompanyGroups();
  
    this.setState({
      ...warrantyDict,
      companyGroups: companyGroups.filter((companyGroup) => !((state || []).includes(companyGroup.id))),
    });

    if (params.warrantyCompanyGroupId) {
      const warrantyCompanyGroup = warrantyDict.groups.find((group) => group.id.toString() === params.warrantyCompanyGroupId);

      this.setState({
        ...warrantyCompanyGroup,
      });
    }
  }

  onInputChange = (name, value) => this.setState({ [name]: value });

  onCompanyGroupChange = (_, companyGroup) => {
    this.setState({
      group: companyGroup,
    });
  }

  handleSave = async () => {
    try {
      const { match: { params } } = this.props;

      const warrantyModel = new WarrantyCompanyGroupModel({ ...this.state });
      const errors = warrantyModel.validate();
      const { group, actualPrice, price } = this.state;

      const payload = {
        warrantyTypeId: params.id,
        group,
        actualPrice,
        price,
      };

      if (params.warrantyCompanyGroupId) {
        payload.id = params.warrantyCompanyGroupId;
      }

      if (!errors) {
        await saveCompanyGroupWarranty(payload);

        this.props.history.goBack();
      }

      this.setState({ errors });
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const {
      name,
      companyGroups,
      errors,
      actualPrice,
      price,
      group,
    } = this.state;
    return (
      <>
        <div className="content">
          <div className="card">
            <div className="card-body">
              <div className="form-horizontal">
                <Input
                  id="name"
                  onChange={() => null}
                  label="Nazwa gwarancji"
                  value={name}
                  horizontal
                  disabled
                />
                <Input
                  id="price"
                  label="Cena"
                  value={price}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />
                <Input
                  id="actualPrice"
                  label="Rzeczywista cena za gwarancje"
                  value={actualPrice}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />
              </div>
              <CustomSelect
                label="Grupy klientów"
                data={{ id: 'companyGroup' }}
                value={group}
                onChange={this.onCompanyGroupChange}
                options={companyGroups}
                errors={errors}
                getOptionValue={getOptionValue}
                getOptionLabel={getOptionLabel}
                horizontal
              />
              <div className="form-group">
                <button
                  type="button"
                  onClick={this.handleSave}
                  className="btn btn-primary float-right"
                >
                  <i className="fa fa-check" />
                  {' '}
                  Zapisz
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

DictWarrantyCompanyGroupForm.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withRouter(DictWarrantyCompanyGroupForm);
